<template>
  <div
    class="m-waggon-intersection-placeholder"
    v-intersect="onintersect"
  >
  <transition
  :name="waggon_transition?'grow-x':''"
  >
    <TWaggon
      v-if="show_waggon"
      :key="`waggon${waggon.id}`"
      :workpackage_count="waggon.tworkpackages.length"
      :easter_egg="false"
      @click.native="openWaggonInfo(waggon, train.id, taktarea.id, waggon.id, $event)"
    >
      <template #content>
        <TPMWorkpackage
        v-for="workpackage in getUObjects({type: 'tworkpackages', ids: waggon.tworkpackages})"
        :key="`workpackagehoveractivator${workpackage.id}`"
        :project_id="project_id"
        :workpackage="workpackage"
        :train="train"
        :taktarea="taktarea"
        :waggon="waggon"
        :easter_egg="false"
        :new_milestone="new_milestone"
        :milestone_selection="milestone_selection"
        :snackbar="snackbar"
        @openWaggonInfo="openWaggonInfo(waggon, train.id, taktarea.id, waggon.id, $event, workpackage.id)"
        />
      </template>
    </TWaggon>
  </transition>
</div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

import TPMWorkpackage from '@/views/Project/ProjectTaktPlanMobile/TPMWorkpackage.wrapper.vue';
import TWaggon from '@/components/ProjectTaktPlan/Waggon.component.vue';


  export default {
    props: [
      'waggon_transition',
      'project_id',
      'train',
      'taktarea',
      'waggon',
      'waggon_index',
      'snackbar',
      'new_milestone',
      'milestone_selection',
    ],
    components: {
      TPMWorkpackage,
      TWaggon,
    },
    data: () => ({
      show_waggon: false,
    }),
    // updated() {
    //   console.log('tpwaggon updated');
    // },
    computed: {
      ...mapGetters('Ultra', [
        'getUObjects',
      ]),
      ...mapGetters('Project', [
        'isEditMode',
      ]),
      ...mapGetters('TaktArea', [
        'getMoveTaktareaStartVariables',
      ]),
      ...mapGetters('SnackBar', [
        'getAffectedTargets'
      ]),
    },
    methods: {
      ...mapActions('Ultra', [
        'createUObject',
        'updateUObjectParent',
        'deleteUObject',
        'updateUObjectPosition',
      ]),
      ...mapActions('SnackBar', [
        'requestSnackbarCreate',
        'requestSnackbarUpdatePosition',
        'requestSnackbarUpdateParent',
        'requestSnackbarDelete',
      ]),
      onintersect(entries, observer, isIntersecting) {
        if (isIntersecting) {
          this.show_waggon = true
        } else {
          this.show_waggon = false
        }
      },
      getDraggableStyle(){
        return {attrs: {'style': `width: calc((var(--workpackage_width) + 4px) * var(--taktplan_zoom)); height: calc((var(--workpackage_height) + 4px) * var(--taktplan_zoom))`}};
      },
      openWaggonInfo(waggon, train_id, taktarea_id, waggon_id, evt, workpackage_id) {
        let x =  -window.innerWidth/2 + evt.clientX;
        let y = -window.innerHeight/2 + evt.clientY;
        document.body.style.setProperty('--waggon_offset_x', `${x}px`);
        document.body.style.setProperty('--waggon_offset_y', `${y}px`);
        if (waggon.tworkpackages.length > 0) {
          this.$router.push({
            name: this.isEditMode?'TaktPlanWorkPackageEdit':'TaktPlanWorkPackageInfo',
            params: {
              train_id: train_id,
              taktarea_id: taktarea_id,
              twaggon_id: waggon_id,
              tworkpackage_id: workpackage_id?workpackage_id:waggon.tworkpackages[0],
              }
            });
        } else if (this.isEditMode) {
          this.$router.push({
            name: 'TaktPlanAddWorkPackage',
            params: {
              train_id: train_id,
              taktarea_id: taktarea_id,
              twaggon_id: waggon_id,
              }
            });
        }
      },
    }
  }
</script>
<style>
  .m-waggon-intersection-placeholder{
    width: calc((var(--workpackage_width) + 8px) * var(--taktplan_zoom));
    height: calc((var(--workpackage_height) + 8px) * var(--taktplan_zoom));
  }
</style>
